import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectDelivery } from '@store/order/selectors';
import { CountryEnum } from '@api/types/CountryEnum';
import { PricingModel } from '@api/types/PricingModel';
import { renderPrice } from '@components/utils';



interface LetterProps {
	price: PricingModel | null | undefined,
	country: CountryEnum,
}


const Letter = (props: LetterProps) => {
	const { price, country } = props;
	const { t } = useTranslation('forms');

	const delivery = useSelector(selectDelivery);
	const productPrice = price && delivery ? renderPrice(price.priceWithVat - delivery.price) : '0';
	const productPriceNoVat = price && delivery ? renderPrice(price.priceNoVat - delivery.price) : '0';

	if (!delivery) return (
		<></>	
	)

	return (
		<div className='order-summary-element letter-element'>
			<p>{t('footer.letter.text1')}</p>
			<p>{t('footer.letter.text2')}</p>
			<p>{t('footer.letter.text3')}</p>
			<p>{t('footer.letter.text4')}</p>
			<p>{t('footer.letter.text5')}</p>

			{price && price.priceNoVat > 0 && <p className='with-margin'>{
				t('footer.letter.text6') + '\u00a0' +
				`${productPrice}\u00a0${country === CountryEnum.cz ? t('units.CZK') : t('units.EUR')} ` +
				`(${productPriceNoVat}\u00a0${country === CountryEnum.cz ? t('units.CZK') : t('units.EUR')} ${t('footer.withoutVat')})` +
				t('footer.letter.text7') + ' ' +
				`${renderPrice(price.priceWithVat)}\u00a0${country === CountryEnum.cz ? t('units.CZK') : t('units.EUR')} ` +
				`(${renderPrice(price.priceNoVat)}\u00a0${country === CountryEnum.cz ? t('units.CZK') : t('units.EUR')} ${t('footer.withoutVat')}).`
			}</p>}

			{price && price.priceNoVat > 0 && <p>{t('footer.letter.text8')}</p>}

			<p className='with-margin'>{t('footer.letter.text9')}</p>
			<p>{t('footer.letter.text10')}</p>

			<p className='with-margin'>{t('footer.letter.text11')}</p>

			<p className='with-margin'>{t('footer.letter.text12')}</p>
		</div>
	);
};

export default Letter;